import type { IconSvgObject } from './types';

const ThermometerWarmIcon: IconSvgObject = [
  ["path", { d: "M10.3133 15.8303C8.67792 15.5416 7.36329 14.104 7.20333 12.2607C7.01373 10.076 8.51806 8.14861 10.5634 7.95588C10.883 7.92576 11.197 7.9398 11.5 7.99327M10 4L10.5 5M6 7.5L5 7M4.5 12.5H3.5M7 17L6 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.5 22C18.7091 22 20.5 20.2091 20.5 18C20.5 16.5194 19.6956 15.2267 18.5 14.5351V4C18.5 2.89543 17.6046 2 16.5 2C15.3954 2 14.5 2.89543 14.5 4V14.5351C13.3044 15.2267 12.5 16.5194 12.5 18C12.5 20.2091 14.2909 22 16.5 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ThermometerWarmIcon;
